import React, { useState, useEffect, useCallback } from "react";
import "./BallotsPage.css";
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import Feeds from "../../Components/Feeds/Feeds";
import DashboardRightSection from "../../Components/DashboardRightSection/DashboardRightSection";
import ScrollNav from "../../Components/ScrollNav/ScrollNav";
import Chatbot from "../../Components/Chatbot/Chatbot";
import { getAllVotesWithFilters, clearStaticCache } from "../../api/Vote";
import { getToken, getUserId } from "../../api/index";

function BallotsPage() {
    const [sharedVotes, setSharedVotes] = useState([]);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const fetchUnifiedData = useCallback(async () => {
        try {
            const token = getToken();
            const userId = getUserId();
            if (!userId || !token) return;

            console.log("Fetching unified data for BallotsPage...");
            const response = await getAllVotesWithFilters({
                userId: userId,
                skip: 0,
                take: 10 // Fetch enough for both Feeds and Sidebar
            }, token);

            setSharedVotes(response || []);
        } catch (error) {
            console.error("Error fetching unified votes:", error);
        } finally {
            setIsInitialLoading(false);
        }
    }, []);

    const onBallotCreated = useCallback(() => {
        console.log("🔄 Unified refresh triggered");
        setIsInitialLoading(true); // Show loading state across components
        clearStaticCache();
        fetchUnifiedData();
        setRefreshTrigger(prev => prev + 1);
    }, [fetchUnifiedData]);

    useEffect(() => {
        fetchUnifiedData();
    }, [fetchUnifiedData]);

    return (
        <div className="BallotsPage">
            <div className="ballotsPageContainer">
                <div className="headerContain">
                    <Header />
                </div>
                <div className="ballotsPageContainer2">
                    <div className="sidebarContain">
                        <Sidebar />
                    </div>
                    <div className="middleContainer">
                        <Feeds
                            initialVotes={sharedVotes}
                            isInitialLoading={isInitialLoading}
                            refreshTrigger={refreshTrigger}
                            onRefresh={onBallotCreated}
                        />
                    </div>
                    <div className="dashboardRightSectionContain">
                        <DashboardRightSection
                            initialVotes={sharedVotes.slice(0, 5)}
                            isInitialLoading={isInitialLoading}
                            refreshTrigger={refreshTrigger}
                        />
                    </div>
                </div>
                <Chatbot onBallotCreated={onBallotCreated} />
                <ScrollNav />
            </div>
        </div>
    );
}

export default BallotsPage;
